module.exports = __webpack_public_path__ + "img/titulo-artistas.966e361b.png";